import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import UploadModal from 'components/Uploads/UploadModal'
import { NavRowContent } from './NavRowContent'
import { useNavTooltip } from './useNavTooltip'

const SelectedModal = ({ item, setShowModal }) => {
  switch (item.key) {
    case 'fileUpload':
      return <UploadModal setShowModal={setShowModal} />
    default:
      return null
  }
}

SelectedModal.propTypes = {
  item: PropTypes.object,
  setShowModal: PropTypes.func,
}

const MainNavModalItem = ({ item, layout }) => {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(false)
  const { linkRef, handleMouseEnter, handleMouseLeave, tooltipNode } = useNavTooltip({
    label: t(`Menu.${item.key}`),
    disabled: layout.sidebarExpanded,
  })

  return (
    <>
      <li
        onClick={() => setShowModal(true)}
        key={item.key}
        id={`main-nav-item-${item.key}`}
        className="main-nav__item white-icon mb-0"
      >
        <div
          ref={linkRef}
          className="main-nav__link c-hover"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <NavRowContent item={item} t={t} sidebarExpanded={layout.sidebarExpanded} />
        </div>

        {tooltipNode}
      </li>
      {showModal && <SelectedModal item={item} setShowModal={setShowModal} />}
    </>
  )
}

MainNavModalItem.propTypes = {
  item: PropTypes.object,
  layout: PropTypes.object,
}

export default MainNavModalItem
